import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Launch } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../common/components';
import messages from '../../messages';

const S = {
  Launch: styled(Launch)`
    margin-right: 8px;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    color: ${({ theme }) => theme.palette.grey[600]};
  `,
};


const ContactExportButton = ({ className, onClick }) => (
  <Button
    className={className}
    type="button"
    variant="outlined"
    onClick={onClick}
  >
    <S.Launch />
    <FormattedMessage {...messages.contactExportButton} />
  </Button>
);

ContactExportButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ContactExportButton.defaultProps = {
  className: undefined,
};


export default ContactExportButton;
